import { useYardStores } from '@yard/AppProvider'
import { YardViewStore } from '@yard/pages/YardSetup/stores/yard.view-store'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { GlobalAllocationRulesViewStore } from '../../../../stores/allocation-rules/global-allocation-rules.view-store'
import { GlobalAllocationRulesAccordion } from '../../../molecules/AllocationRules/GlobalAllocationRules/GlobalAllocationRulesAccordion'
import { GlobalRulesDrawerHeader } from '../../../molecules/AllocationRules/GlobalAllocationRules/GlobalRulesDrawerHeader'
import { UnallocatedContainersAccordion } from '../../../molecules/AllocationRules/UnallocatedContainersAccordion'
import { YardLeftDrawer } from '../../../molecules/YardLeftDrawer'
import { AllocationRulesDialogs } from '../AllocationRuleDialogs'

interface Props {
  yardViewStore: YardViewStore
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
}
export const GlobalAllocationRulesDrawer: FC<Props> = observer(props => {
  const { yardViewStore, globalAllocationRulesViewStore } = props
  const { allocationRuleStore } = useYardStores()

  const handleFromLibrary = async () => {
    await allocationRuleStore.loadTemplateRules()
    globalAllocationRulesViewStore.toggleTemplateDialog()
  }

  return (
    <>
      <YardLeftDrawer
        open={
          globalAllocationRulesViewStore.isAllocationRulesDrawerOpen && yardViewStore.isViewMode
        }
        onClose={() => globalAllocationRulesViewStore.setAllocationRulesDrawerOpen(false)}
      >
        <GlobalRulesDrawerHeader
          onCreateNewRule={() => globalAllocationRulesViewStore.toggleFormDialog()}
          onImportFromLibrary={handleFromLibrary}
        />

        <GlobalAllocationRulesAccordion
          globalAllocationRulesViewStore={globalAllocationRulesViewStore}
          isEditable={yardViewStore.isViewMode}
        />

        <UnallocatedContainersAccordion
          unallocatedJourneys={globalAllocationRulesViewStore.unallocatedContainers}
        />
      </YardLeftDrawer>

      <AllocationRulesDialogs
        yardViewStore={yardViewStore}
        allocationRulesViewStore={globalAllocationRulesViewStore}
      />
    </>
  )
})
